@if (loading()) {
  <div class="matter-cell">
    <div class="skeleton-line medium"></div>
    <div class="skeleton-line long"></div>
    <div class="skeleton-line medium"></div>
  </div>
} @else if (routerLink()) {
  <a
    class="matter-cell cell-link"
    [routerLink]="routerLink()"
    [state]="linkState()"
  >
    <ng-container [ngTemplateOutlet]="lines"></ng-container>
  </a>
} @else if (link()) {
  <a class="matter-cell cell-link" (click)="onClick()">
    <ng-container [ngTemplateOutlet]="lines"></ng-container>
  </a>
} @else {
  <div class="matter-cell">
    <ng-container [ngTemplateOutlet]="lines"></ng-container>
  </div>
}

<ng-template #lines>
  @if (clientName()) {
    <div class="client-name">{{ clientName() }}</div>
  }
  <div class="matter-name">{{ matterName() || matterNameFallback() }}</div>
  <div class="matter-number">{{ matterNumber() }}</div>
</ng-template>
